import { parseISO } from 'date-fns';
import { IApplicationState } from '../../types/redux';
import { formatMonth } from '../../utils/date';

export const selectFormattedDate = (state: IApplicationState): string => {
  const { date } = state.filters;

  return formatMonth(parseISO(date)) + ' ' + new Date(date).getFullYear();
};
